import { render, staticRenderFns } from "./MailDN.vue?vue&type=template&id=5d750ab2&scoped=true"
import script from "./MailDN.vue?vue&type=script&lang=js"
export * from "./MailDN.vue?vue&type=script&lang=js"
import style0 from "./MailDN.vue?vue&type=style&index=0&id=5d750ab2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d750ab2",
  null
  
)

export default component.exports